import { render, staticRenderFns } from "./rc-crm-organization-meta-data.vue?vue&type=template&id=e96a5864&scoped=true&"
import script from "./rc-crm-organization-meta-data.vue?vue&type=script&lang=js&"
export * from "./rc-crm-organization-meta-data.vue?vue&type=script&lang=js&"
import style0 from "./rc-crm-organization-meta-data.vue?vue&type=style&index=0&id=e96a5864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96a5864",
  null
  
)

export default component.exports